<div class="container">
  <div class="row justify-content-center">
    <div class="col-12 col-sm-8">
      <div class="bolder spacing">
        Elevate Your Residency Program with the Orthopaedic Powerhouse of ROCK, ResStudy & OITE
      </div>
      <div>Imagine: a seamlessly integrated suite of resources empowering your residents to excel by utilizing a blend
        of foundational knowledge, self-assessment, and exam preparation, all thoughtfully curated by orthopaedic
        experts. This is the ROCK, ResStudy & OITE Bundle.
      </div>
      <div class="bold spacing">
        Unleash a Comprehensive Learning Journey:
      </div>
      <div>
        <ol>
          <li><strong>ROCK:</strong> Dive into 11 subspecialties with 545 expert-written chapters and 3,400 test
            questions. ROCK is the
            cornerstone of the core knowledge needed to take residency education to the next level. </li>
          <li><strong>ResStudy:</strong> Master self-assessment with an interactive question bank. Identify strengths,
            target weaknesses,
            and gain actionable insights with detailed explanations. </li>
          <li><strong>OITE:</strong> Prepare for board exams with year-specific practice questions. Each question links
            to relevant ROCK
            chapters, guiding residents to targeted knowledge reinforcement. </li>
        </ol>
      </div>
      <div class="bold ">
        Unlock Synergy for Your Program:
      </div>
      <div>
        <ol>
          <li><strong>Tailored Learning Pathways:</strong> Adapt ROCK's features to fit your program's goals and
            residents' needs. Benchmark against other programs for continuous improvement. </li>
          <li><strong>Resident Progress Tracking:</strong> Monitor performance across all three tools to identify areas
            for support and intervention. </li>
          <li><strong>Data-Driven Insights: </strong> Generate comprehensive reports to understand strengths and
            weaknesses across the entire learning spectrum. </li>
        </ol>
      </div>
      <div class="">
        New for 2025-2026 Academic Year - Bundle pricing on ortho's most powerful suite of residency tools. 
      </div>
      <div class="bold">
        Save $146 on ROCK when you bundle it with ResStudy and OITE - and gain the full power of all three orthopaedic residency tools. 
      </div>
      <div class="bold ">
        Activate Your Program's Success:  
      </div>
      <div class="">
        Contact AAOS customer service at 800-626-6726 to unlock the power of this bundled solution and empower your residents to soar.   
      </div>
      <aaos-app-resident-curriculum-table></aaos-app-resident-curriculum-table>
    </div>
  </div>
</div>